export const waterDict = {
  factor: {
    waterLevel: {
      unit: '',
      name: '水质级别',
      colorRank: [
        { color: '74EEEE', rank: [1], sign: 'I类' },
        { color: '1FCAF9', rank: [2], sign: 'II类' },
        { color: '38D978', rank: [3], sign: 'III类' },
        { color: 'EBDE29', rank: [4], sign: 'IV类' },
        { color: 'FFA302', rank: [5], sign: 'V类' },
        { color: 'FB0006', rank: [6], sign: '劣V类' },
      ],
    },
    cod: {
      unit: 'mg/L',
      name: 'COD',
      colorRank: [
        { color: '74EEEE', rank: [0, 15], sign: '0' },
        { color: '1FCAF9', rank: [15, 15], sign: '15' },
        { color: '38D978', rank: [15, 20], sign: '15' },
        { color: 'EBDE29', rank: [20, 30], sign: '20' },
        { color: 'FFA302', rank: [30, 40], sign: '30' },
        { color: 'FB0006', rank: [40, '~'], sign: '40' },
      ],
    },
    nh3n: {
      unit: 'mg/L',
      name: '氨氮',
      colorRank: [
        { color: '74EEEE', rank: [0, 0.15], sign: '0' },
        { color: '1FCAF9', rank: [0.15, 0.5], sign: '0.15' },
        { color: '38D978', rank: [0.5, 1], sign: '0.5' },
        { color: 'EBDE29', rank: [1, 1.5], sign: '1' },
        { color: 'FFA302', rank: [1.5, 2], sign: '1.5' },
        { color: 'FB0006', rank: [2, '~'], sign: '2' },
      ],
    },
    tp: {
      unit: 'mg/L',
      name: '总磷',
      colorRank: [
        { color: '74EEEE', rank: [0, 0.02], sign: '0' },
        { color: '1FCAF9', rank: [0.02, 0.1], sign: '0.02' },
        { color: '38D978', rank: [0.1, 0.2], sign: '0.1' },
        { color: 'EBDE29', rank: [0.2, 0.3], sign: '0.2' },
        { color: 'FFA302', rank: [0.3, 0.4], sign: '0.3' },
        { color: 'FB0006', rank: [0.4, '~'], sign: '0.4' },
      ],
    },
    tn: {
      unit: 'mg/L',
      name: '总氮',
      colorRank: [
        { color: '74EEEE', rank: [0, 0.2], sign: '0' },
        { color: '1FCAF9', rank: [0.2, 0.5], sign: '0.2' },
        { color: '38D978', rank: [0.5, 1], sign: '0.5' },
        { color: 'EBDE29', rank: [1, 1.5], sign: '1' },
        { color: 'FFA302', rank: [1.5, 2], sign: '1.5' },
        { color: 'FB0006', rank: [2, '~'], sign: '2' },
      ],
    },
    dissolvedOxygen: {
      unit: 'mg/L',
      name: '溶解氧',
      colorRank: [
        { color: '74EEEE', rank: [20, 7.5], sign: '20' },
        { color: '1FCAF9', rank: [7.5, 6], sign: '7.5' },
        { color: '38D978', rank: [6, 5], sign: '6' },
        { color: 'EBDE29', rank: [5, 3], sign: '5' },
        { color: 'FFA302', rank: [3, 2], sign: '3' },
        { color: 'FB0006', rank: [2, 0], sign: '2' },
      ],
    },
    codMn: {
      unit: 'mg/L',
      name: '高锰酸盐指数',
      colorRank: [
        { color: '74EEEE', rank: [0, 2], sign: '0' },
        { color: '1FCAF9', rank: [2, 4], sign: '2' },
        { color: '38D978', rank: [4, 6], sign: '4' },
        { color: 'EBDE29', rank: [6, 10], sign: '6' },
        { color: 'FFA302', rank: [10, 15], sign: '10' },
        { color: 'FB0006', rank: [15, '~'], sign: '15' },
      ],
    },
  },
  colorForValue: {
    '00e400': '优',
    ffff00: '良',
    ff7e00: '轻度',
    ff0000: '中度',
    '99004c': '重度',
    '7e0023': '严重',
    '6e6e6e': '无',
  },
  colorForFont: {
    '#00e400': '#000',
    '#ffff00': '#000',
    '#ff7e00': '#fff',
    '#ff0000': '#fff',
    '#99004c': '#fff',
    '#7e0023': '#fff',
    '#6e6e6e': '#fff',
  },
};

export const formatWaterValueToLevel = (v, t) => {
  if (!t) return '--';
  const vs = (waterDict.factor[t] || waterDict.factor[t.toLowerCase()] || {}).colorRank;
  if (t.toLowerCase() === 'dissolvedoxygen') {
    for (let i = 0; i < vs.length; i++) {
      if (vs[i].rank[1] <= v && v < vs[i].rank[0]) {
        return i;
      }
    }
  } else {
    for (let i = 0; i < vs.length; i++) {
      if (vs[i].rank.length === 1 && vs[i].rank[0] === v * 1) {
        return i;
      } else if (
        (vs[i].rank[0] === 0 ? vs[i].rank[0] <= v : vs[i].rank[0] < v) &&
        v <= (vs[i].rank[1] === '~' ? Infinity : vs[i].rank[1])
      ) {
        return i;
      }
    }
  }
  return '--';
};
